/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Toast_OpenInputs */

const en_us2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const pt_br2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const es_419_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const pt_pt2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const fr_fr2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const de_de2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const it_it2_push_toast_open = /** @type {(inputs: Push_Toast_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Push_Toast_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_toast_open = /** @type {((inputs?: Push_Toast_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Toast_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_toast_open(inputs)
	if (locale === "es-419") return es_419_push_toast_open(inputs)
	if (locale === "pt-PT") return pt_pt2_push_toast_open(inputs)
	if (locale === "fr-FR") return fr_fr2_push_toast_open(inputs)
	if (locale === "de-DE") return de_de2_push_toast_open(inputs)
	if (locale === "it-IT") return it_it2_push_toast_open(inputs)
	return en_us2_push_toast_open(inputs)
});
export { push_toast_open as "push.toast_open" }